import React, { useState } from "react";
import { useSelector } from "react-redux";
import DesignLayout from "hoc/DesignLayout/DesignLayout";
import DesignHeader from "./components/DesignHeader/DesignHeader";
import { Switch, Redirect } from "react-router-dom";
import PrivateRoute from "hoc/Routes/PrivateRoute/PrivateRoute";
import Unit from "./Unit/Unit";

function Design(props) {
  const { isLoggedIn } = useSelector((state) => ({
    isLoggedIn: state.auth.isLoggedIn,
  }));

  return (
    <DesignLayout>
      <DesignHeader />
      <main>
        <Switch>
          <Redirect exact from="/design" to="/design/unit" />
          <Redirect exact from="/design/new" to="/design/unit" />
            <PrivateRoute
              path="/design/unit"
              component={Unit}
              restricted
              isLoggedIn={isLoggedIn}
            />
        </Switch>
      </main>
    </DesignLayout>
  );
}

export default Design;
